import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { IPreDefinedRange } from 'libs/design-system/src/types/date_range_picker';
import type { TAppliedRanges } from '@app/dashboard/types/innerLayout/date-ranges';

import DateRanges from '@app/dashboard/components/inner_layout/DateRanges';
import { mainPreDefinedRanges as preDefinedRanges } from '@app/dashboard/utils/dateRangePicker';
import { getLang } from '@app/dashboard/utils/localStorageUtils';
import { formatToISODateTimeUTC } from '@app/dashboard/utils/dateFormats';

import styles from './header.module.scss';

export interface IQuickLinksFilters {
  created_at__gte?: string;
  created_at__lte?: string;
  reference_id?: string;
  currency?: string;
  state?: string;
  amount_cents__gte?: string;
  amount_cents__lte?: string;
  phone_number?: string;
  client_url?: string;
}

interface IHeaderProps {
  filters: IQuickLinksFilters;
  onFiltersChange: (filters: IQuickLinksFilters) => void;
  appliedFiltersCount: number;
}

export const Header = ({ filters, onFiltersChange }: IHeaderProps) => {
  const { t } = useTranslation();
  const lang = getLang();

  const wrapperRef = useRef<any>();

  const defaultPreDefinedRange: IPreDefinedRange | undefined = preDefinedRanges(t)?.find((range) => range.default);

  const [appliedRanges, setAppliedRanges] = useState<TAppliedRanges>({
    index: defaultPreDefinedRange?.index,
    name: defaultPreDefinedRange?.name,
    start: defaultPreDefinedRange?.selectionRange[0],
    end: defaultPreDefinedRange?.selectionRange[1],
  });

  const handleDateRangeChange = (ranges: TAppliedRanges) => {
    setAppliedRanges(ranges);
    if (ranges.start && ranges.end) {
      onFiltersChange({
        ...filters,
        created_at__gte: formatToISODateTimeUTC(
          ranges.start,
          '+03:00',
          'start'
        ),
        created_at__lte: formatToISODateTimeUTC(ranges.end, '+03:00', 'end'),
      });
    }
  };

  return (
    <div className={styles['header']} ref={wrapperRef}>
      <div className={styles['header__title']}>
        {t('innerLayout.quickLinksPage.title')}
      </div>

      <DateRanges
        appliedRanges={appliedRanges}
        handleRangesChange={handleDateRangeChange}
        lang={lang}
      />
    </div>
  );
};
